<template>
  <div class="views-content--cad-library">
    <banner-generic :data="data.hero"></banner-generic>

    <section class="item-filter space--sm">
      <div class="container filter-desktop">
        <div class="row">
          <div class="col-xs-12">

            <div class="filter-wrapper filter-wrapper--text-only">
              <div class="filter-wrapper--label">Categories</div>

              <div class="filter-wrapper--hide-scroll">
                <div class="inner" id="filter-wrapper--primary" @scroll="slideOnScroll('filter-wrapper--primary')">
                  <div class="items">
                    <a href="#" 
                      class="category" 
                      :class="[selectedFilter.category.includes(category.urlsegment) ? 'selected' : null]" 
                      v-for="(category, index) in filterKeys.categories" :key="index"
                      @click.prevent="setFilter(category.filterid, 'category', category)"
                      :data-id="category.filterid"
                    >
                      {{ category.title }}
                    </a>
                    <div class="spacer">&nbsp;</div>
                  </div>
                </div>
              </div>
              
              <button id="filter-wrapper--prev--primary" class="filter-wrapper--prev" @click="slidePrev('filter-wrapper--primary')">
                  <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                  </svg>
              </button>

              <button id="filter-wrapper--next--primary" class="filter-wrapper--next" @click="slideNext('filter-wrapper--primary')">
                  <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                  </svg>
              </button>
            </div>

            <div class="filter-wrapper filter-wrapper--text-icon">
              <div class="filter-wrapper--label">Tags</div>

              <div class="filter-wrapper--hide-scroll">
                <div class="inner" id="filter-wrapper--secondary" @scroll="slideOnScroll('filter-wrapper--secondary')">
                  <div class="items">
                    <a href="#" @click.prevent="setFilter('reset-this-filter', 'tag', null)" :class="[
                      selectedFilter.tag.length <= 0 ? 'selected' : null
                    ]">All</a>

                    <a href="#" v-for="(tag, index) in filterKeys.tags" :class="[
                      selectedFilter.tag.includes(tag.urlsegment) ? 'selected' : null
                    ]" :key="index" @click.prevent="setFilter(tag.filterid, 'tag', tag)"
                      :data-id="tag.filterid">{{ tag.title }}</a>

                    <div class="spacer">&nbsp;</div>
                  </div>
                </div>
              </div>
              
              <button id="filter-wrapper--prev--secondary" class="filter-wrapper--prev" @click="slidePrev('filter-wrapper--secondary')">
                  <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                  </svg>
              </button>

              <button id="filter-wrapper--next--secondary" class="filter-wrapper--next" @click="slideNext('filter-wrapper--secondary')">
                  <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                  </svg>
              </button>
            </div>

            <div class="filter-wrapper--separator"></div>

          </div>
        </div>
      </div>

      <div class="container filter-wrapper--mobile">
        <div class="wrapper">
          <button @click="toggleMobileFilter()" :class="mobileFilter ? 'expanded' : ''">Filter</button>
          <div class="buttons" :class="mobileFilter ? '' : 'hidden'">
            <div class="primary">
              <a href="#" @click.prevent="setFilter('reset-all-filter', null, null)" 
                class="category"
                :class="[
                  selectedFilter.category.length <= 0 && selectedFilter.tag.length <= 0 ? 'selected' : null
                ]"
              >Show all</a>
            </div>
            <div class="primary">
              <a href="#" class="category" :class="[
                  selectedFilter.category.includes(category.urlsegment) ? 'selected' : null
                ]" v-for="(category, index) in filterKeys.categories" :key="index"
                @click.prevent="setFilter(category.filterid, 'category', category)"
                :data-id="category.filterid"
              >{{ category.title }}</a>
            </div>
            <div class="secondary">
              <a href="#" v-for="(tag, index) in filterKeys.tags" 
                class="tag"
                :class="[
                  selectedFilter.tag.includes(tag.urlsegment) ? 'selected' : null
                ]" 
                :key="index" 
                @click.prevent="setFilter(tag.filterid, 'tag', tag)"
                :data-id="tag.filterid"
              >{{ tag.title }}</a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div v-if="totalItems<=0" class="no-items text-center padding--lg">
      no items available
    </div>
    
    <div v-else class="padding--lg">
      <div class="container">
        <div class="items-wrapper">
          <div v-for="(item, index) in filteredItems" :key="index" class="card card--cad-lib">
            <div class="side--up">
              <div class="image-wrap">
                <img class="main-image" :src="item.thumbnail" />
                <button class="show-image" @click="showPopupImage(item.imageFull, item.title)">
                  <img src="/_resources/themes/colorsteel/dist/assets/images/cadlib/icon-image-zoom.png" alt="zoom" />
                </button>
              </div>
              <div class="subtext">{{ item.subtext }}</div>
              <h2>{{ item.title }}</h2>
              <div class="content" v-if="item.content" v-html="item.content"></div>
            </div>
            <div class="side--down">
              <div class="download-label">Download files</div>
              <div class="download-list">
                <a v-for="(link, idx2) in item.files" :key="idx2" :href="link.url" download>
                  <img :src="'/_resources/themes/colorsteel/dist/assets/images/cadlib/icon-' + link.type + '.svg'"
                    :alt="'icon ' + link.type" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="space-bottom--xl">
      <div v-if="itemCount<totalItems" class="container text-center">
        <button class="button button--solid-black" @click="getFilteredItems(true)">Show More</button>
      </div>
    </div>

    <!-- elements -->
    <div v-for="(element, index) in data.elements" :key="element.id">
      <component :class="elementClass(element.vueName, index)" :is="element.vueName" :data="alteredElements[index]"
        @addNeighbourClass="addNeighbourClassHandle" />
    </div>
  </div>
</template>

<script>
import viewsElementClasses from '../mixins/viewsElementClasses';
import { BannerGeneric, Cta } from "../components";
import bus from '../utilities/eventbus';
import axios from 'axios';

// elements
import { ElementAccordion, ElementBackgroundImage, ElementContent, ElementCTA, ElementColours, ElementImage, ElementLinks, ElementImages, ElementProducts, ElementSplitSlider, ElementTiles, ElementVideo, ElementPercentage } from "../components";

export default {
  name: "v-cadlibrary",
  mixins: [viewsElementClasses],
  components: {
    BannerGeneric,
    Cta,
    // Elements
    ElementAccordion,
    ElementBackgroundImage,
    ElementColours,
    ElementContent,
    ElementCTA,
    ElementLinks,
    ElementImages,
    ElementImage,
    ElementProducts,
    ElementSplitSlider,
    ElementTiles,
    ElementVideo,
    ElementPercentage
  },
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      itemCount: 0,
      totalItems: 0,
      filteredItems: [],
      selectedFilter: {
        category: [],
        tag: []
      },
      selectedFilterID: {
        category: [],
        tag: []
      },
      filterKeys: {
        categories: [],
        tags: []
      },
      mobileFilter: false,
      intervalID: 0
    }
  },
  methods: {
    toggleMobileFilter() {
      this.mobileFilter = !this.mobileFilter;
    },
    showPopupImage(url, title) {
      bus.$emit('eventPopupShow', {url: url, title: title});
    },
    setFilter(key, type, obj) {
      if (key === 'reset-all-filter') {
        this.selectedFilter['category'] = [];
        this.selectedFilterID['category'] = [];
        this.selectedFilter['tag'] = [];
        this.selectedFilterID['tag'] = [];
      } else if(key === 'reset-this-filter') {
        this.selectedFilter[type] = [];
        this.selectedFilterID[type] = [];
      } else {
        let value = obj.urlsegment;
        let id = obj.id;

        if (this.selectedFilter[type].includes(value)) {
          this.selectedFilter[type].splice(this.selectedFilter[type].indexOf(value), 1);
          this.selectedFilterID[type].splice(this.selectedFilterID[type].indexOf(id), 1);
        } else {
          if (type === 'category') {
            this.selectedFilter[type] = [value];
            this.selectedFilterID[type] = [id];
          } else {
            this.selectedFilter[type].push(value);
            this.selectedFilterID[type].push(id);
          }
        }
      } 

      this.getFilteredItems(false);
    },
    getFilteredItems(isLoadMore) {
      let params = [];
      if(this.selectedFilterID.category.length>0){
        params.push(`category=${this.selectedFilterID.category.join(',')}`);
      }
      if(this.selectedFilterID.tag.length>0){
        params.push(`tags=${this.selectedFilterID.tag.join(',')}`);
      }
      if(isLoadMore){
        params.push(`offset=${this.itemCount}`);
      }

      let url = `/cad-library-items/?${params.join('&')}`;
      axios.get(url)
        .then(response => {
          if(isLoadMore){
            this.filteredItems = this.filteredItems.concat(response.data.data);
          }else{
            this.filteredItems = response.data.data;
          }
          this.itemCount = this.filteredItems.length;
          this.totalItems = response.data.totalItems;
        })
        .catch(error => {
          console.log(error);
        })
    },
    slidePrev(id) {
        const elem = document.getElementById(id);
        elem.scrollBy(window.innerWidth/3 * (-1), 0);
    },
    slideNext(id) {
        const elem = document.getElementById(id);
        elem.scrollBy(window.innerWidth/3, 0);
    },
    slideOnScroll(id) {
        const slideBuffer = 10;
        const elem = typeof id === 'string' ? document.getElementById(id) : id;
        const isScrolling = elem.querySelector('.items').offsetWidth > elem.offsetWidth;

        elem.parentNode.parentNode.classList.add('no-scroll');
        if(isScrolling){
            elem.parentNode.parentNode.classList.remove('no-scroll');
        }

        if(isScrolling && elem.scrollLeft >= (elem.querySelector('.items').offsetWidth - elem.offsetWidth - slideBuffer)) {
            elem.parentNode.parentNode.classList.add('is-max');
            elem.parentNode.parentNode.classList.remove('is-min');
        } else if(isScrolling && elem.scrollLeft <= slideBuffer) {
            elem.parentNode.parentNode.classList.remove('is-max');
            elem.parentNode.parentNode.classList.add('is-min');
        } else {
            elem.parentNode.parentNode.classList.remove('is-max');
            elem.parentNode.parentNode.classList.remove('is-min');
        }
    },
    detectButtonVisibility() {
        let status = true;

        const slideItems = [
            document.getElementById('filter-wrapper--primary'),
            document.getElementById('filter-wrapper--secondary')
        ];
        const slideButtons = [
            document.getElementById('filter-wrapper--next--primary'),
            document.getElementById('filter-wrapper--next--secondary')
        ];

        slideItems.forEach((elem, index) => {
            if(elem){
                if(elem.querySelector('.items').offsetWidth<=0) status = false;
                if(elem.querySelector('.items').offsetWidth<=elem.offsetWidth){
                    slideButtons[index].classList.add('hidden');
                }else{
                    slideButtons[index].classList.remove('hidden');
                }

                this.slideOnScroll(elem);
            }
        });

        return status;
    }
  },
  mounted() {
    this.filterKeys.categories = this.restructureFilterArray(this.data.categories, 'category');
    this.filterKeys.tags = this.restructureFilterArray(this.data.tags, 'tag');
    this.filteredItems = this.data.items.data;
    this.itemCount = this.filteredItems.length;
    this.totalItems = this.data.items.totalItems;

    const app = this;

    this.intervalID = setInterval(() => {
        let status = app.detectButtonVisibility();
        if(status) clearInterval(this.intervalID );
    }, 100);

    window.addEventListener('resize', () => {
        clearTimeout(this.intervalID);
        this.intervalID = setTimeout(() => {
            app.detectButtonVisibility();
        }, 250);
    });
  }
};
</script>

<style lang="scss">
@import "../../scss/abstracts/variables";

.items-wrapper {
  display: grid;
  gap: 30px;
  flex-wrap: wrap;
  grid-template-columns: repeat(3, minmax(0, 1fr));

  @media (max-width:1024px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width:767px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}

.card--cad-lib {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-bottom: 1px solid #000000;
  padding-bottom: 40px;
  margin-bottom: 30px;

  .image-wrap {
    position: relative;
    border: 1px solid #2D2C2C;

    .show-image {
      position: absolute;
      cursor: pointer;
      z-index: 5;
      border: none;
      background: none;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      padding: 15px;
      display: flex;
      justify-content: flex-end;

      img {
        display: block;
        width: 24px;
        height: 24px;
      }
    }
  }

  img.main-image {
    display: block;
    aspect-ratio: 4 / 3;
    object-fit: cover;
    width: 100%;
  }

  .subtext {
    margin-top: 30px;
    font-family: 'Pitch Semi Bold';
    font-size: 14px;
    line-height: 2.14285;
  }

  h2 {
    margin: 0;
    font-family: 'Untitled Sans Medium';
    font-size: 24px;
    line-height: 1.416667;
  }

  .content {
    margin-top: 15px;
  }

  .download-label {
    font-size: 14px;
    line-height: 1.8571;
    margin-top: 15px;
  }

  .download-list {
    margin-top: 35px;
    display: flex;
    flex-wrap: wrap;
    gap: 15px;

    a {
      transition: all 300ms;

      &:hover {
        opacity: 0.5;
      }

      img {
        display: block;
        width: 40px;
      }
    }
  }
}

.views-content--cad-library {
  .filter-desktop {
    @media (max-width: 767px) {
      display: none;
    }
  }

  .filter-wrapper--mobile {
    padding-top: 30px;

    @media (min-width: 768px) {
      display: none;
    }
  }
}
</style>